import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-newreception',
  templateUrl: './newreception.component.html',
  styleUrls: ['./newreception.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})

export class NewreceptionComponent implements OnInit {

  receptionURLID:any;
  SuggestProducts:boolean;

  DocumentDate = new FormControl(moment());
  PaymentDueDate =  new FormControl(moment());
  StockEntryDate =  new FormControl(moment());
  CollectionDate = new FormControl(moment());

  loadingEditProduct = false;
  showAddNewPartnerPopUp = false;
  showEditPartnerPopUp = false;

  // Custom Dropdown show/hide states
  showDocTypeDropdown = false;
  showSeriesDropdown = false;
  showCurrencyDropdown = false;
  showDecimalPrecisionDropdown = false;
  showAdministrationDropdown = false;
  showMeasuringUnitDropdown = false;
  showVATDropdown = false;
  showProductTypeDropdown = false;
  showCountryDropdown = false;
  showBankDropdown = false;
  showEditCountryDropdown = false;
  showEditBankDropdown = false;

  // Payment popup dropdown states
  showPaymentTypeDropdown = false;
  showPaymentCurrencyDropdown = false;
  showPaymentBankAccountDropdown = false;
  showPaymentDecimalPrecisionDropdown = false;

  //new partner members
  newPartnerCountry:any;
  newPartnerBank:any;
  masterData:any;
  DocumentBodyLoading:boolean;

  newPartner:any;
  partner:any;
  currentPartner:any;
  currency:any;
  showAccountingSeriesError:boolean;

  searchTerm:string;

  countryID:number;

  resultsLength = 0;
  pageSize = 999999;

  Partners:any[];

  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  DiscountTypes:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  TaxDivisionTypes:any[];
  ReceivedStatuses:any[];

  NewProductPriceContainsVAT:boolean;
  IsStorno:boolean;
  PreImportUIID:string;

  ReceptionPrecision:any;
  TotalRowDecimalPrecision:any;
  IsValidNewProduct:boolean;

  Products:any[];

  ProductsSearchResults:any[];
  ProductsSearchResultsCOUNT:any;

  ProductsSearchResultsPop:any[];
  ProductsSearchResultsCOUNTPop:any;

  loadingSearchProducts:boolean;
  loadingPOMatch:boolean;
  loadingPOMatchIndex:number = 0;
  loadingPOMatchTotal:number = 0;

  NewProduct:any;
  CurrentProduct:any;
  CurrentIndexProduct:number;
  CurrentReception: {[k: string]: any} = {};
  currentPayment:{[k: string]: any} = {};

  SavedReception:boolean;
  showReceptionVisualizer:boolean;
  ShowDocumentError:boolean;

  showSearch:boolean;
  showSearchCurrent:boolean;

  // Import with Indexes properties
  ShowImportWithIndexesPopup:boolean;
  selectedExcelFile: File = null;
  ConfigurationPositions:any[];

  // Import Indexes Dropdown States
  showCodeIndexDropdown: boolean = false;
  showNameIndexDropdown: boolean = false;
  showQuantityIndexDropdown: boolean = false;
  showPriceIndexDropdown: boolean = false;
  showTotalIndexDropdown: boolean = false;

  newBlogForm: FormGroup;
  searchPartnerUpdate = new Subject<string>();

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { 

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

      // Debounce search.
      this.searchPartnerUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetPartnersFiltered(value, this.countryID, true);
        });
  }

  ngOnInit(): void {

    this.SavedReception = false;
    this.getParamValues();
    this.Products = new Array();
    this.countryID = null;
    this.masterData = this.parent.masterData;
    this.initializeAddPartnerForm();
    this.GetReceptionsMasterData();
    this.GetPaymentsMasterData();

    this.IsValidNewProduct = false;
    this.showProductDiscountContainer = false;
    this.ProductsSearchResultsCOUNT = 0;
    this.showSearch = true;
    this.showSearchCurrent = true;

    // Initialize Import with Indexes
    this.ShowImportWithIndexesPopup = false;
    this.GetImportConfigurationPositions();

    if(this.receptionURLID != undefined && this.receptionURLID != null){
      this.GetReception(this.receptionURLID, false);
    }

    if(this.PreImportUIID != null && this.PreImportUIID?.length > 0){
      this.GetIndexedDBReceptionValue(this.PreImportUIID);
    }

    this.newBlogForm = new FormGroup({
      Name: new FormControl(null),
      UploadedFile: new FormControl(null)
    });

    this.GetShippingMasterData();
    this.parent.PreventBrowserClose(true);
  }

  GetIndexedDBReceptionValue(key:string){
    this.parent.readIndexedDBObject(this.PreImportUIID)
    .then((storedValue) => {

      // Check if the storedValue is a string, then parse it
      if (typeof storedValue === 'string') {
      let parsedObject: any;
         
          parsedObject = JSON.parse(storedValue); // Safely parse the JSON string
          this.GetPreImportedReception(parsedObject);
          
      }else 
      {
      } 
    })
  }

  showhideSearches(isFromPop:boolean){
    
    if(isFromPop){
      if(this.ProductsSearchResultsCOUNTPop > 0){
        this.showSearchCurrent = !this.showSearchCurrent;
      }
      else{
        this.showSearchCurrent = true;
      }
    }
    else{
      if(this.ProductsSearchResultsCOUNT > 0){
        this.showSearch = !this.showSearch;
      }
      else{
        this.showSearch = true;
      }
    }
  }

  GetPreImportedReception(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Reception:r,
    };

    this.loadingEditProduct = true;

    this.service.GetPreImportedReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 30000);
        this.ShowDocumentError = true;
      }
      else if(response["Status"] == 1){
        this.FillReceptionInfo(response["Reception"]);
        this.TestDocumentValidity();

        this.CurrentReception.Company = this.parent.Company;
        this.parent.deleteIndexedDBObject(this.PreImportUIID);
      }
   
      this.loadingEditProduct = false;
    });
  }

  GetReception(id:string, IncludeTaxDistributionsInPrice:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:id,
      WithInfo:true,
      IsNewStorno:this.IsStorno,
      IncludeTaxDistributionsInPrice:IncludeTaxDistributionsInPrice
    };

    this.loadingEditProduct = true;

    this.service.GetReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 30000);
        this.ShowDocumentError = true;
      }
      else if(response["Status"] == 1){
        this.FillReceptionInfo(response["Reception"]);

        if(IncludeTaxDistributionsInPrice){
          this.CurrentReception = response["Reception"];
          this.CurrentReception.Products = this.CurrentReception.Products.filter(x => x.ProductReceptionInfo.GeneralType.IsTaxConsumed != true);
        }

        this.TestDocumentValidity();
      }
   
      this.loadingEditProduct = false;
    });
  }

  FillReceptionInfo(reception:any){

    this.partner = {};
    this.partner = reception.Supplier;

    this.CurrentReception = {};
    this.CurrentReception.ID = reception.ID;
    this.CurrentReception.Supplier = reception.Supplier;
    this.CurrentReception.DocType = reception.DocType;
    this.CurrentReception.AccountingNumber = reception.AccountingNumber;
    this.CurrentReception.Company = reception.Company;
    this.CurrentReception.Currency = reception.Currency;

    this.CurrentReception.DocumentNumber = reception.DocumentNumber;

    this.CurrentReception.DocumentDate = reception.DocumentDate;
    this.CurrentReception.PaymentDueDate = reception.PaymentDueDate;
    this.CurrentReception.StockEntryDate = reception.StockEntryDate;

    this.DocumentDate = new FormControl(moment(this.CurrentReception.DocumentDate));
    this.PaymentDueDate =  new FormControl(moment(this.CurrentReception.PaymentDueDate));
    this.StockEntryDate =  new FormControl(moment(this.CurrentReception.StockEntryDate));

    this.currency = reception.Currency;

    if(reception.Products.length > 0){
      this.ReceptionPrecision = reception.Products[0].ProductReceptionInfo.DecimalPrecision;
    }

    this.TotalRowDecimalPrecision = reception.TotalRowDecimalPrecision;
    this.Products = reception.Products;

    this.CurrentReception.Details = {};
    this.CurrentReception.Details.ID = reception.Details.ID;
    this.CurrentReception.Details.Observations = reception.Details.Observations;
    this.CurrentReception.Details.InternalCommentary = reception.Details.InternalCommentary;
    this.CurrentReception.Details.ReceptionCommittee = reception.Details.ReceptionCommittee;
    this.CurrentReception.Details.Delegate = reception.Details.Delegate;
    this.CurrentReception.Details.Auto = reception.Details.Auto;
    this.CurrentReception.Details.PaymentRemainingValue = reception.Details.PaymentRemainingValue;
    this.CurrentReception.Details.Payments = reception.Details.Payments;
    this.CurrentReception.Details.ReceivedStatus = reception.Details.ReceivedStatus;
    this.CurrentReception.Details.ForceDocumentClosing = reception.Details.ForceDocumentClosing;
    this.CurrentReception.Details.ETransportDetails = reception.Details.ETransportDetails;

    this.CurrentReception.Total = {};
    this.CurrentReception.Total = reception.Total;

    this.CurrentReception.EventRegisterUI = reception.EventRegisterUI;

    this.CurrentReception.DocumentStatus = reception.DocumentStatus;
    this.CurrentReception.Status = reception.Status;
    this.CurrentReception.IsStorno = reception.IsStorno;
    this.CurrentReception.Products = reception.Products;
    this.CurrentReception.FilePath = reception.FilePath;
    this.IsStorno = reception.IsStorno;

    // Initialize ImportIndexes if not present
    if (!this.CurrentReception.ImportIndexes) {
      this.CurrentReception.ImportIndexes = {
        Name: null,
        Code: null,
        Quantity: null,
        Price: null,
        Total: null,
        VAT: null
      };
    }
  }
  
  getParamValues() {
    this.route.queryParams.subscribe(params => {      

        if(params['id'] != null){
          this.receptionURLID = JSON.parse(JSON.stringify(params['id']));
        }

        if(params['IsStorno'] != null){
          this.IsStorno = JSON.parse(JSON.stringify(params['IsStorno']));
        }

        if(this.IsStorno == undefined){
          this.IsStorno = false;
        }
        if(params["PreImportUIID"] != null){
          this.PreImportUIID = JSON.parse(JSON.stringify(params["PreImportUIID"]));
        }
    });
  }

  InitializeNewReception(){

    this.CurrentReception.AccountingNumber = {};
    this.CurrentReception.AccountingNumber.ID = null;
    this.CurrentReception.AccountingNumber.AccountingSeries = {};
    this.CurrentReception.AccountingNumber.AccountingSeries = this.AccountingSeries[0];
    this.CurrentReception.Supplier = {};
    this.CurrentReception.Company = {};
    this.CurrentReception.Company = this.parent.Company;
    this.CurrentReception.DocType = {};
    this.CurrentReception.DocType = this.DocTypes[0];
    this.CurrentReception.DocumentNumber = "";
    this.CurrentReception.DocumentDate = {};
    this.CurrentReception.PaymentDueDate = {};
    this.CurrentReception.StockEntryDate = {};
    this.CurrentReception.Currency = {};
    this.CurrentReception.Products = [];
    this.CurrentReception.Products = this.Products;
    this.CurrentReception.Details = {};
    this.CurrentReception.Details.ReceivedStatus = JSON.parse(JSON.stringify(this.ReceivedStatuses[0]));
    this.CurrentReception.Details.ForceDocumentClosing = false;
    this.CurrentReception.ID = null;

    this.CurrentReception.DocumentStatus = {};
    this.CurrentReception.DocumentStatus.ID = 1;

    this.CurrentReception.IsStorno = this.IsStorno;

    this.CurrentReception.Total = {};
    this.CurrentReception.Total.Discount = {};

    // Initialize ImportIndexes with all properties
    this.CurrentReception.ImportIndexes = {
      Name: null,
      Code: null,
      Quantity: null,
      Price: null,
      Total: null,
      VAT: null
    };
  }

  InitializeNewProduct(){

    var Administration = null;

    if(this.NewProduct?.ProductReceptionInfo?.Administration != null){
      Administration = JSON.parse(JSON.stringify(this.NewProduct?.ProductReceptionInfo?.Administration));
    }
    else{
      Administration = JSON.parse(JSON.stringify(this.Administrations[0]));
    }

    this.NewProduct = {
      ID:null,
      GeneralType:this.ProductGeneralTypes[0],
      ProductReceptionInfo:{
        Administration:Administration,
        Name:"",
        Code:"",
        MeasuringUnit:this.MeasuringUnits[0],
        Quantity:1,
        DocQuantity:1,
        Price:{
          VAT:this.VATRates[0]
        },
        Total:null,
        TotalVATValue:null,
      },
    };

    this.IsValidNewProduct = false;
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

  compareFirst(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

  initializeAddPartnerForm(){
    this.newPartner = new FormGroup({

      VAT:new FormControl(''),
      UPN:new FormControl(''),
      Name:new FormControl('', [Validators.required]),
      COCRegNumber:new FormControl(''),
  
      TaxPayer:new FormControl(''),
  
      Country:new FormControl(''),
      StateProvince:new FormControl(''),
      City:new FormControl(''),
      AddressLine:new FormControl('', [Validators.required]),
      ZipCode:new FormControl(''),

      Bank:new FormControl(''),
      BankAccount:new FormControl(''),
  
      Email: new FormControl('', [Validators.email]),
      ContactName:new FormControl(''),
      Phone:new FormControl(''),
    });
  }

  initializePartnerFormFromObject(partner:any){

    this.currentPartner = new FormGroup({

      VAT:new FormControl(partner.VAT),
      UPN:new FormControl(partner.UPN),
      Name:new FormControl(partner.Name, [Validators.required]),
      COCRegNumber:new FormControl(partner.COCRegNumber),
  
      TaxPayer:new FormControl(partner.TaxPayer),
  
      Country:new FormControl(partner.BillingAddress.Country),
      StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
      City:new FormControl(partner.BillingAddress.City, [Validators.required]),
      AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),
      ZipCode:new FormControl(partner.BillingAddress.ZipCode),

      Bank:new FormControl(partner.Bank),
      BankAccount:new FormControl(partner.Bank.BankAccount),
  
      Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
      ContactName:new FormControl(partner.ContactInfo.Name),
      Phone:new FormControl(partner.ContactInfo.Phone),
    });
   
    this.showEditPartnerPopUp = true;
    this.partner = partner;
  }

  AddNewPartner(){

    var request = {
      Partner:{
        VAT:this.newPartner.controls['VAT'].value,
        UPN:this.newPartner.controls['UPN'].value,
        Name:this.newPartner.controls['Name'].value,
        COCRegNumber:this.newPartner.controls['COCRegNumber'].value,

        TaxPayer:false,

        BillingAddress:{
          Country:this.newPartner.controls['Country'].value,
          StateProvince:this.newPartner.controls['StateProvince'].value,
          City:this.newPartner.controls['City'].value,
          AddressLine:this.newPartner.controls['AddressLine'].value,
          ZipCode:this.newPartner.controls['ZipCode'].value,
        },
        Bank:this.newPartnerBank,
        ContactInfo:{
          Email:this.newPartner.controls['Email'].value,
          Name:this.newPartner.controls['ContactName'].value,
          Phone:this.newPartner.controls['Phone'].value,
        },
        Company:this.parent.Company
      },
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    if(request.Partner.Bank != null){
      request.Partner.Bank.BankAccount = this.newPartner.controls['BankAccount'].value;
    }

    if(this.newPartner.controls['TaxPayer'].touched != false && this.newPartner.controls['TaxPayer'].value != ''){
      request.Partner.TaxPayer = this.newPartner.controls['TaxPayer'].value;
    }
    else{
      request.Partner.TaxPayer = false;
    }
    
    if(this.newPartner.valid){

      this.parent.loading = true;

      this.service.AddNewPartner(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["DuplicateDetected"]){
            this.parent.openSnackBar(this.parent.translate.instant("Management.DuplicatePartnerDetected") + ": " + (response["Partner"]?.Name || response["Message"]), "OK", "alert-danger-snackbar");
          } else {
            this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
          }
          this.initializeAddPartnerForm();
          this.showAddNewPartnerPopUp = false;
          this.GetPartnerOnAdd(response["ID"]);
        }

        this.parent.loading = false;
      });
       };

     if(!this.newPartner.valid){
      this.newPartner.controls['Name'].touched = true;
      this.newPartner.controls['Country'].touched = true;
      this.newPartner.controls['StateProvince'].touched = true;
      this.newPartner.controls['City'].touched = true;
      this.newPartner.controls['AddressLine'].touched = true;
      this.newPartner.controls['ZipCode'].touched = true;
      }
    }

  GetPartnerOnAdd(id:string){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:id
      };
  
      this.parent.loading = true;
  
      this.service.GetPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.partner = response["Partner"];
          this.resultsLength = 0;
          this.searchTerm='';
          this.AdjustCurrencyOnPartnerSeleciton();
          this.GetDocumentDupplication(this.partner, this.CurrentReception.DocumentNumber, this.CurrentReception.ID);
          this.MatchUnallocatedUIT(this.partner, this.CurrentReception.DocumentNumber);
          this.TestDocumentValidity();
        }
     
        this.parent.loading = false;
      });
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company,
      SearchEUVIES:true
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["NewPartnerDetected"] == true){
  
            var p = response["PendingPartner"];
            this.newPartner = new FormGroup({
  
              VAT:new FormControl(p.VAT),
              UPN:new FormControl(''),
              Name:new FormControl(p.Name, [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(p.EUVATVerified),
          
              Country:new FormControl(p.BillingAddress.Country),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(p.BillingAddress.AddressLine),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
  
            this.showAddNewPartnerPopUp = true;
          }
          else{
            this.Partners = response["Partners"];
            this.resultsLength = response["Count"];
          }
        }
     
        this.parent.loading = false;
      });
    }
  }

  UpdatePartner(){
    var request = {
      Partner:{
        ID:String,
        VAT:this.currentPartner.controls['VAT'].value,
        UPN:this.currentPartner.controls['UPN'].value,
        Name:this.currentPartner.controls['Name'].value,
        COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,

        TaxPayer:this.currentPartner.controls['TaxPayer'].value,

        BillingAddress:{
          ID:Number,
          Country:this.currentPartner.controls['Country'].value,
          StateProvince:this.currentPartner.controls['StateProvince'].value,
          City:this.currentPartner.controls['City'].value,
          AddressLine:this.currentPartner.controls['AddressLine'].value,
          ZipCode:this.currentPartner.controls['ZipCode'].value,
        },
        Bank:this.currentPartner.controls['Bank'].value,
        ContactInfo:{
          ID:Number,
          Email:this.currentPartner.controls['Email'].value,
          Name:this.currentPartner.controls['ContactName'].value,
          Phone:this.currentPartner.controls['Phone'].value,
        },
        Company:this.parent.Company,
        EUVATVerified:this.partner.EUVATVerified,
      },
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
    request.Partner.ID = this.partner.ID;
    request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
    request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;

    this.parent.loading = true;

    this.service.UpdatePartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
       this.showEditPartnerPopUp = false;
       this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
       this.partner = response["Partner"];
      }
   
      this.parent.loading = false;
    });
  }

  public query(searchText: string) {
    this.GetPartnersFiltered(searchText, this.countryID, true);
  }

  GetReceptionsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    var x = this.DocumentDate

    this.parent.loading = true;

    this.service.GetReceptionsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DocTypes = response["DocTypes"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];

        if(this.AccountingSeries == null || this.AccountingSeries.length == 0){
          if(this.receptionURLID == undefined || this.receptionURLID == null){
            this.OpenAccountingSeriesError();
          }
        }

        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.currency = this.Currencies[0];
        this.ReceptionPrecision = this.DecimalPrecisions[0];
        this.TotalRowDecimalPrecision = this.DecimalPrecisions[0];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DiscountTypes = response["DiscountTypes"];
        this.TaxDivisionTypes = response["TaxDivisionTypes"];
        this.ReceivedStatuses = response["ReceivedStatuses"];
        
        this.NewProductPriceContainsVAT = false;

      }
   
      this.InitializeNewReception();
      this.InitializeNewProduct();
      this.parent.loading = false;
    });

  }

  OpenAccountingSeriesError(){
    this.showAccountingSeriesError = true;
  }

  InsertPartnerFromCloud(partner:any){

    var request = {
      Partner:partner,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.AddNewPartner(request).subscribe(response => {

      if(response["Status"] != 1){

      }
      else if(response["Status"] == 1){
        this.partner.ID = response["ID"];
        this.partner.EUVATVerified = response["EUVATVerified"];
        if(response["DuplicateDetected"]){
          this.parent.openSnackBar(this.parent.translate.instant("Management.DuplicatePartnerDetected") + ": " + (response["Partner"]?.Name || ""), "OK", "alert-danger-snackbar");
        } else {
          this.parent.openSnackBar(this.parent.translate.instant("Management.AddNewPartner"), "OK", "light-info-snackbar");
        }
      }

      this.parent.loading = false;
    });
  }

  ValidateVATNumberEU(partner:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.ValidateVATNumberEU(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerEUData(partner:any, addnew:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){

        if(addnew){

          this.newPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(''),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(''),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(''),
            City:new FormControl(''),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(''),
        
            Bank:new FormControl(''),
            BankAccount:new FormControl(''),
        
            Email: new FormControl('', [Validators.email]),
            ContactName:new FormControl(''),
            Phone:new FormControl(''),
          });
        }
        else{

          this.currentPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(this.partner.UPN),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(this.partner.COCRegNumber),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
            City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(this.partner.BillingAddress.ZipCode),

            Bank:new FormControl(this.partner.Bank),
            BankAccount:new FormControl(this.partner.Bank.BankAccount),
        
            Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
            ContactName:new FormControl(this.partner.ContactInfo.Name),
            Phone:new FormControl(this.partner.ContactInfo.Phone),
          });

          this.partner.EUVATVerified = response["EUVATVerified"];
        }
      }
   
      this.parent.loading = false;
    });
  }

  GetCurrencyLiveExchange(currency:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Currency:currency
    };

    this.parent.loading = true;

    this.service.GetCurrencyLiveExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.currency = response["Currency"];
      }
   
      this.parent.loading = false;
    });
  }

  AddProductToReception(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:this.NewProduct.ProductReceptionInfo.Price,
      Precision:this.ReceptionPrecision.ID,
      HasVAT:this.NewProductPriceContainsVAT,
      Quantity:this.NewProduct.ProductReceptionInfo.Quantity,
      DocQuantity:this.NewProduct.ProductReceptionInfo.DocQuantity,
      IsStorno:this.IsStorno
    };
  
    this.parent.loading = true;

    this.service.GetPriceInformation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

          var aux = JSON.parse(JSON.stringify(this.NewProduct));

          aux.ProductReceptionInfo.Price = response["Price"];

          aux.ProductReceptionInfo.Price.Currency = this.currency;
          aux.ProductReceptionInfo.DecimalPrecision = this.ReceptionPrecision;
          aux.ProductReceptionInfo.PriceContainsVAT = this.NewProductPriceContainsVAT;
          aux.ProductReceptionInfo.GeneralType = this.NewProduct.GeneralType;
          aux.ProductReceptionInfo.Quantity = response["Quantity"];
          aux.ProductReceptionInfo.DocQuantity = response["DocQuantity"];
         
          aux.ProductReceptionInfo.UIID = this.parent.newGuid();
          this.Products.push(aux);
          this.TestDocumentValidity();
          this.GetExpectedPOProductsPrices(aux, this.partner);
      }
   
      this.GetReceptionTotalValues();
      this.InitializeNewProduct();
      this.parent.loading = false;
    });

  }

  GetExpectedPOProductsPrices(product:any, supplier:any){

    var receptionDate = this.DocumentDate?.value?._d ? moment(this.DocumentDate.value._d).format('YYYY-MM-DD') : null;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:supplier,
      Product:product,
      ReceptionDate:receptionDate
    };

    this.parent.loading = true;

    this.service.GetExpectedPOProductsPrices(request).subscribe(response => {

      if(response["Status"] != 1){
      }
      else if(response["Status"] == 1){
        this.Products.forEach(element => {
          if(element.ProductReceptionInfo.UIID == product.ProductReceptionInfo.UIID){
            element.ProductReceptionInfo.ExpectedPOProductInfo = response["ExpectedPOProductInfo"];
          }
        });
      }

      this.parent.loading = false;
    });

  }

  GetExpectedPOProductsPricesBulk(products:any[], supplier:any){

    if(!products || products.length === 0){
      return;
    }

    var receptionDate = this.DocumentDate?.value?._d ? moment(this.DocumentDate.value._d).format('YYYY-MM-DD') : null;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:supplier,
      Products:products,
      ReceptionDate:receptionDate
    };

    this.parent.loading = true;

    this.service.GetExpectedPOProductsPricesBulk(request).subscribe(response => {

      if(response["Status"] != 1){
        // Silent fail - expected PO prices are optional information
      }
      else if(response["Status"] == 1){
        // Update the Products array with the returned ExpectedPOProductInfo items matched by UIID
        if(response["ExpectedPOProducts"] && response["ExpectedPOProducts"].length > 0){
          response["ExpectedPOProducts"].forEach((info: any) => {
            this.Products.forEach(element => {
              if(element.ProductReceptionInfo.UIID == info.UIID){
                element.ProductReceptionInfo.ExpectedPOProductInfo = info;
              }
            });
          });
        }
      }

      this.parent.loading = false;
    });

  }

  LoadPOProductInfoBulk(){
    if(!this.Products || this.Products.length == 0) return;
    if(this.loadingPOMatch) return;
    if(!this.partner) return;

    var matchableProducts = this.Products.filter(x => x.ProductReceptionInfo?.GeneralType?.ID == 1);
    if(matchableProducts.length == 0) return;

    this.loadingPOMatch = true;
    this.loadingPOMatchIndex = 0;
    this.loadingPOMatchTotal = matchableProducts.length;

    var receptionDate = this.DocumentDate?.value?._d ? moment(this.DocumentDate.value._d).format('YYYY-MM-DD') : null;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Partner: this.partner,
      Products: matchableProducts,
      ReceptionDate: receptionDate,
      ReceptionID: this.CurrentReception?.ID
    };

    this.service.GetExpectedPOProductsPricesBulk(request).subscribe(response => {
      if(response["Status"] == 1 && response["ExpectedPOProducts"] && response["ExpectedPOProducts"].length > 0){
        response["ExpectedPOProducts"].forEach((info: any) => {
          this.Products.forEach(element => {
            if(element.ProductReceptionInfo.UIID == info.UIID){
              element.ProductReceptionInfo.ExpectedPOProductInfo = info;
            }
          });
        });
      }

      this.loadingPOMatchIndex = matchableProducts.length;
      this.loadingPOMatch = false;
    });
  }

  GetReceptionTotalValues(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Products:JSON.parse(JSON.stringify(this.Products)),
      Precision:this.TotalRowDecimalPrecision.ID,
      IsStorno:this.IsStorno
    };

    this.parent.loading = true;

    this.service.GetReceptionTotalValues(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        this.CurrentReception.Total.TotalQtyPriceNOVAT = response["Total"].TotalQtyPriceNOVAT;
        this.CurrentReception.Total.TotalVAT = response["Total"].TotalVAT;
        this.CurrentReception.Total.TotalQtyPriceVAT = response["Total"].TotalQtyPriceVAT;
      }
   
      this.parent.loading = false;
    });

  }

  GetSingleExchange(price:any, exchangeRate:any, targetMainCurrency:boolean, precision:any): any{

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:price,
      ExchangeRate:exchangeRate,
      IsTargetMainCurrency:targetMainCurrency,
      Precision:precision
    };

    this.loadingEditProduct = true;

    this.service.GetSingleExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        return response["Price"];
      }
   
      this.loadingEditProduct = false;
    });

    return null;
  }

  DeleteAuxProduct(id:string){

    this.Products = this.Products.filter(item => item.ProductReceptionInfo.UIID != id);
    this.GetReceptionTotalValues();
  }

  chanveNewProductVALUE(event){
    
    this.IsValidNewProduct = false;

    if(this.NewProduct.ProductReceptionInfo.Administration != null){
      if(this.NewProduct.ProductReceptionInfo.MeasuringUnit != null){
        if(this.NewProduct.ProductReceptionInfo.Price.VAT != null){
          if(this.ReceptionPrecision != null){
            if(this.NewProduct.ProductReceptionInfo.Name != null && this.NewProduct.ProductReceptionInfo.Name.length > 0){
              if(this.NewProduct.ProductReceptionInfo.Code != null && this.NewProduct.ProductReceptionInfo.Code.length > 0){
                if(this.NewProduct.ProductReceptionInfo.Price != null){
                  if((this.NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice != null && this.NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice.toString().length > 0 && this.NewProductPriceContainsVAT) || (this.NewProduct.ProductReceptionInfo.Price.UIUnitPrice != null && this.NewProduct.ProductReceptionInfo.Price.UIUnitPrice.toString().length > 0 && !this.NewProductPriceContainsVAT)){
                    if(this.NewProduct.ProductReceptionInfo.Quantity > 0 && this.NewProduct.ProductReceptionInfo.DocQuantity > 0 && this.NewProduct.ProductReceptionInfo.Code.length > 0 && this.NewProduct.ProductReceptionInfo.Name.length > 0){
                      this.IsValidNewProduct = true;
                    }
                  }
                }
              }
           }
          }
        }
      }
    }
  }

  MirrorDocQuantity(event){
    this.NewProduct.ProductReceptionInfo.DocQuantity = JSON.parse(JSON.stringify(this.NewProduct.ProductReceptionInfo.Quantity));
  }

  AdjustProductsDecimalPrecisionPrice(){

      setTimeout(()=>{                         
        if(this.Products != undefined && this.Products != null && this.Products.length > 0){
          this.Products.forEach(p => {
            this.CurrentProduct = JSON.parse(JSON.stringify(p));
            this.CurrentProduct.ProductReceptionInfo.DecimalPrecision = this.ReceptionPrecision;

            var request = {
              User:this.parent.User,
              Language:this.parent.getLanguage(),
              Price:this.CurrentProduct.ProductReceptionInfo.Price,
              Precision:this.ReceptionPrecision.ID,
              HasVAT:this.CurrentProduct.ProductReceptionInfo.PriceContainsVAT,
              Quantity:this.CurrentProduct.ProductReceptionInfo.Quantity,
              DocQuantity:this.CurrentProduct.ProductReceptionInfo.DocQuantity,
              IsStorno:this.IsStorno,
              Discount:null
            };
        
            if(this.CurrentProduct.ProductReceptionInfo.Price.Discount != undefined){
              request.Discount = this.CurrentProduct.ProductReceptionInfo.Price.Discount;
            }
        
            this.service.GetPriceInformation(request).subscribe(response => {
           
              if(response["Status"] != 1){
                this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
              }
              else if(response["Status"] == 1){
                 
                  this.CurrentProduct.ProductReceptionInfo.Quantity = response["Quantity"];
                  this.CurrentProduct.ProductReceptionInfo.DocQuantity = response["DocQuantity"];
                  this.CurrentProduct.ProductReceptionInfo.Price = response["Price"];
                  p.ProductReceptionInfo.Price = this.CurrentProduct.ProductReceptionInfo.Price;
                  p.ProductReceptionInfo.DecimalPrecision = this.ReceptionPrecision;
                  this.GetReceptionTotalValues();
              }
            });
          });
        }
      }, 0);
  }

  ShowReceptionEditProductContainer:boolean;
  ReserveProduct:any;

  OpenReceptionEditProduct(id:string){

    this.Products.forEach(p => {
      if(p.ProductReceptionInfo.UIID == id){
        this.CurrentProduct = JSON.parse(JSON.stringify(p));
        this.ReserveProduct = JSON.parse(JSON.stringify(this.CurrentProduct));
        this.ShowReceptionEditProductContainer = true;
      }
    });
  }

  RevertProduct(){
    this.CurrentProduct = this.ReserveProduct;

    for (let i = 0; i < this.Products.length ; i++) {
      if(this.Products[i].ProductReceptionInfo.UIID == this.CurrentProduct.ProductReceptionInfo.UIID){
        this.Products[i] = JSON.parse(JSON.stringify(this.CurrentProduct));
      }
    }
    
  }

  ModifyReceptionProduct(maintainOpenPopUp:boolean = false){

  var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:this.CurrentProduct.ProductReceptionInfo.Price,
      Precision:this.ReceptionPrecision.ID,
      HasVAT:this.CurrentProduct.ProductReceptionInfo.PriceContainsVAT,
      Quantity:this.CurrentProduct.ProductReceptionInfo.Quantity,
      DocQuantity:this.CurrentProduct.ProductReceptionInfo.DocQuantity,
      IsStorno:this.IsStorno,
      Discount:null
    };

    if(this.CurrentProduct.ProductReceptionInfo.Price.Discount != undefined){
      request.Discount = this.CurrentProduct.ProductReceptionInfo.Price.Discount;
    }

    if(maintainOpenPopUp == false){
      this.loadingEditProduct = true;
    }

    this.service.GetPriceInformation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
         
          this.CurrentProduct.ProductReceptionInfo.Quantity = response["Quantity"];
          this.CurrentProduct.ProductReceptionInfo.DocQuantity = response["DocQuantity"];

          this.CurrentProduct.ProductReceptionInfo.Price = response["Price"];
          this.CurrentProduct.ProductReceptionInfo.Price.Currency = this.currency;

          if(maintainOpenPopUp == false){
            this.ShowReceptionEditProductContainer = false;
          }

          this.showProductDiscountContainer = false;
          this.Products[this.CurrentIndexProduct] = JSON.parse(JSON.stringify(this.CurrentProduct));
          this.GetExpectedPOProductsPrices(JSON.parse(JSON.stringify(this.CurrentProduct)), this.partner);
      }
   
      this.GetReceptionTotalValues();
      this.loadingEditProduct = false;
    });
  }

  priceContainsVATchanged($event){

    if($event.checked == true){

      if(this.CurrentProduct != null){
        this.CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductReceptionInfo.Price.UIUnitPrice));
      }

      if(this.NewProduct != null){
        this.NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductReceptionInfo.Price.UIUnitPrice));
      }
    }
    else{
      if(this.CurrentProduct != null){
        this.CurrentProduct.ProductReceptionInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPrice));
      }

      if(this.NewProduct != null){
        this.NewProduct.ProductReceptionInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductReceptionInfo.Price.UIUnitPrice));
      }
    }

    if(this.CurrentProduct != null){
      this.ModifyReceptionProduct(true);
    }
  }

  ForceReception:boolean = false;
  ShowNoDocumentNumberError:boolean = false;

  AddReception(){

    if((this.CurrentReception?.DocumentNumber?.length > 0) != true){
      if(this.ForceReception == false){
        this.ShowNoDocumentNumberError = true;
        return;
      }
    }

    this.CurrentReception.Supplier = this.partner;
    this.CurrentReception.Currency = this.currency;
    
    if (this.DocumentDate.value._d != undefined) {
      this.CurrentReception.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.PaymentDueDate.value._d != undefined) {
      this.CurrentReception.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.StockEntryDate.value._d != undefined) {
      this.CurrentReception.StockEntryDate = moment(this.StockEntryDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentReception.Currency.DecimalPrecision = this.ReceptionPrecision;
    this.CurrentReception.TotalRowDecimalPrecision = this.TotalRowDecimalPrecision;
    this.CurrentReception.Products = this.Products;
    this.CurrentReception.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Reception:this.CurrentReception
    };

    this.parent.loading = true;

    this.service.AddReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.ID = response["ID"];
        this.IsStorno = false;
        this.SavedReception = true;
        this.VizualizeDocument();
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.DocumentDate = new FormControl(moment(this.CurrentReception.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentReception.PaymentDueDate));
      this.StockEntryDate =  new FormControl(moment(this.CurrentReception.StockEntryDate));
      this.parent.loading = false;
    });
  }

  UpdateReception(){

    if((this.CurrentReception?.DocumentNumber?.length > 0) != true){
      if(this.ForceReception == false){
        this.ShowNoDocumentNumberError = true;
        return;
      }
    }

    this.CurrentReception.Supplier = this.partner;
    this.CurrentReception.Currency = this.currency;

    if (this.DocumentDate.value._d != undefined) {
      this.CurrentReception.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.PaymentDueDate.value._d != undefined) {
      this.CurrentReception.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.StockEntryDate.value._d != undefined) {
      this.CurrentReception.StockEntryDate = moment(this.StockEntryDate.value._d).format('YYYY-MM-DD');
    }
    
    this.CurrentReception.Currency.DecimalPrecision = this.ReceptionPrecision;
    this.CurrentReception.TotalRowDecimalPrecision = this.TotalRowDecimalPrecision;
    this.CurrentReception.Products = this.Products;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Reception:this.CurrentReception
    };

    this.parent.loading = true;

    this.service.UpdateReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SavedReception = true;
        this.VizualizeDocument();
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.DocumentDate = new FormControl(moment(this.CurrentReception.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentReception.PaymentDueDate));
      this.StockEntryDate =  new FormControl(moment(this.CurrentReception.StockEntryDate));
   
      this.parent.loading = false;
    });
  }

  VizualizeDocument(){
    this.GetReception(this.CurrentReception.ID, true);
    this.showReceptionVisualizer = true;
  }

  GetProductsFiltered(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:this.pageSize,
      IncludeStock:false
    };

    if(searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;

      this.service.GetProductsFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
        }
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  SearchProductsReceptionInformation(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:10,
      IncludeStock:false,
      Partner:this.partner,
      GeneralDocType:this.parent.masterData.GeneralDocTypes[0].ID,
      PurchaseMasterData:this.parent.masterData,
      NewProductPriceContainsVAT:this.NewProductPriceContainsVAT,
      DecimalPrecision:this.ReceptionPrecision,
      SuggestFromPool:true,
    };

    if(searchTermProducts != null && searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;
  
      this.service.SuggestProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
         }
        }
       
        this.loadingSearchProducts = false;
      });
    }
  }

  DestroySearchedProducts(){
    this.ProductsSearchResultsCOUNT = 0;
      this.ProductsSearchResults = [];

      if(this.NewProduct != undefined){
        if(this.NewProduct.ProductReceptionInfo != null){
          this.NewProduct.ProductReceptionInfo.Name = "";
          this.NewProduct.ProductReceptionInfo.Code = "";
          this.NewProduct.ProductReceptionInfo.ProductID = null;
        }

        this.NewProduct.ID = null;
      }
      
      if(this.CurrentProduct != undefined){
        if(this.CurrentProduct.ProductReceptionInfo != null){
          this.CurrentProduct.ProductReceptionInfo.Name = "";
          this.CurrentProduct.ProductReceptionInfo.Code = "";
          this.CurrentProduct.ProductReceptionInfo.ProductID = null;
        }

          this.CurrentProduct.ID = null;
      }
  
      this.IsValidNewProduct = false;
      this.ProductsSearchResultsCOUNTPop = 0;
      this.ProductsSearchResultsPop = [];
  }

  SelectReceptionProductFromSearch(product:any){

    if(product.ProductReceptionInfo != null){
      this.NewProduct = product;
      this.NewProductPriceContainsVAT = this.NewProduct.ProductReceptionInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductReceptionInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }

    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNT = 0;
    this.ProductsSearchResults = [];
  }

  SelectReceptionProductFromSearchCurrent(product:any){
    
    if(product.ProductReceptionInfo != null){
      product.ProductReceptionInfo.ProductID = product.ID;
      product.ProductReceptionInfo.DecimalPrecision = this.CurrentProduct.ProductReceptionInfo.DecimalPrecision;
      product.ProductReceptionInfo.Description = this.CurrentProduct.ProductReceptionInfo.Description;
      product.ProductReceptionInfo.DescriptionRows = this.CurrentProduct.ProductReceptionInfo.DescriptionRows;
      product.ProductReceptionInfo.DocQuantity = this.CurrentProduct.ProductReceptionInfo.DocQuantity;
      product.ProductReceptionInfo.Quantity = this.CurrentProduct.ProductReceptionInfo.Quantity;
      product.ProductReceptionInfo.Price = this.CurrentProduct.ProductReceptionInfo.Price;
      product.ProductReceptionInfo.PriceContainsVAT = this.CurrentProduct.ProductReceptionInfo.PriceContainsVAT;
      product.ProductReceptionInfo.Total = this.CurrentProduct.ProductReceptionInfo.Total;
      product.ProductReceptionInfo.TotalVATValue = this.CurrentProduct.ProductReceptionInfo.TotalVATValue;
      product.ProductReceptionInfo.VAT = this.CurrentProduct.ProductReceptionInfo.VAT;

      this.CurrentProduct = product;
      this.NewProductPriceContainsVAT = this.CurrentProduct.ProductReceptionInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductReceptionInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }
    
    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNTPop = 0;
    this.ProductsSearchResultsPop = [];
  }

  GetMostRecentProductInformation(p:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      GeneralDocType:this.parent.masterData.GeneralDocTypes[0].ID,
      DecimalPrecision:this.ReceptionPrecision,
      Product:p,
      Partner:this.partner,
      PartnerIsClient:false,
    };
   
      this.loadingSearchProducts = true;

      this.service.GetMostRecentProductInformation(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.IsValidNewProduct = false;
          this.chanveNewProductVALUE(null);
        }
     
        this.loadingSearchProducts = false;
      });
  }

  showProductDiscountContainer:boolean;
  showDocumentDiscountContainer:boolean;

  OpenProductDiscountContainer(p:any){

    if(p != null){
      this.CurrentProduct = JSON.parse(JSON.stringify(p));
      this.showProductDiscountContainer = true;
    }
  }

  OpenDocumentDiscountContainer(){
    this.showDocumentDiscountContainer = true;
  }

  ApplyDiscount(){

    this.Products.forEach(p => {
      if(p.ProductReceptionInfo.UIID == this.CurrentProduct.ProductReceptionInfo.UIID){
        p.ProductReceptionInfo = this.CurrentProduct.ProductReceptionInfo;
        this.ModifyReceptionProduct();
      }
    });
    
  }

  RadioChangeDiscountType($event: MatRadioChange){
    
  }

  ApplyReceptionDiscount(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Reception:JSON.parse(JSON.stringify(this.CurrentReception))
    };

    request.Reception.Products = JSON.parse(JSON.stringify(this.Products));

    this.parent.loading = true;

    this.service.ApplyReceptionDiscount(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception = response["Reception"];
        this.Products = response["Reception"].Products;
      }
   
      this.showDocumentDiscountContainer = false;
      this.parent.loading = false;
    });
  }

  EliminateProductDiscount(){
    this.CurrentProduct.ProductReceptionInfo.Price.Discount = {
      Type:null,
      Value:null
    };

    this.ModifyReceptionProduct();
  }

  EliminateDocumentDiscount(){
    this.CurrentReception.Total.Discount = {
      Type:null,
      Value:null
    };

    this.ApplyReceptionDiscount();
  }

  printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

   download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

  ExportReception(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:r.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.DocumentBodyLoading = false;
    });
  }

  PrintReception(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:r.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.DocumentBodyLoading = false;
    });
  }

  ShowProductTaxDivisionContainer:boolean;
  IsLoadingTaxDivision:boolean;

  GetTaxDivisionCalculation(currentProductID:string){

    var products = [];
    var taxProducts = [];

    this.Products.forEach(p => {
      if(p.ProductReceptionInfo.GeneralType.ID == 1){
        products.push(p);
      }
      else {
        if(p.ProductReceptionInfo.UIID != currentProductID){
          taxProducts.push(p);
        }
      }
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Products:products,
      TaxProduct:this.CurrentProduct
    };

    this.IsLoadingTaxDivision = true;

    this.service.GetTaxDivisionCalculation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Products = response["Products"];
        
        taxProducts.forEach(p => {
          this.Products.push(p);
        });
      }

      this.IsLoadingTaxDivision = false;
    });
  }

  OpenProductTaxDivision(id:string){

    this.Products.forEach(p => {
      if(p.ProductReceptionInfo.UIID == id){
        this.CurrentProduct = p;

        if(this.CurrentProduct.ProductReceptionInfo.GeneralType.TaxDivisionType == null || this.CurrentProduct.ProductReceptionInfo.GeneralType.TaxDivisionType == undefined){
          this.CurrentProduct.ProductReceptionInfo.GeneralType.TaxDivisionType = {};
          this.CurrentProduct.ProductReceptionInfo.GeneralType.TaxDivisionType.ID = 1;
        }

        this.ShowProductTaxDivisionContainer = true;
        this.GetTaxDivisionCalculation(id);
      }
    });
  }

  RadioChangeTaxDivisionType($event: MatRadioChange){
    this.CurrentProduct.ProductReceptionInfo.GeneralType.TaxDivisionType = $event.value;
    this.GetTaxDivisionCalculation(this.CurrentProduct.ProductReceptionInfo.UIID);
  }

  SubmitTaxProductDistribution(){

    this.Products.forEach(p => {
      if(p.ProductReceptionInfo.UIID == this.CurrentProduct.ProductReceptionInfo.UIID){
        
        p.ProductReceptionInfo.GeneralType.IsTaxConsumed = true;
        this.ShowProductTaxDivisionContainer = false;
      }
    });
  }

  CancelTaxProductDistribution(){
    
    this.Products.forEach(p => {
      if(p.ProductReceptionInfo.UIID == this.CurrentProduct.ProductReceptionInfo.UIID){
        
        p.ProductReceptionInfo.GeneralType.IsTaxConsumed = false;
        this.CurrentProduct.ProductReceptionInfo.GeneralType.IsTaxConsumed = false;
        this.ShowProductTaxDivisionContainer = false;
      }
    });
  }

  ETransportUnAllocatedUIT:any;
  ETransportDetails:{[k: string]: any} = {};

  MatchUnallocatedUIT(Partner:any, DocumentNumber:string){

      if((this.CurrentReception?.Details?.ETransportDetails?.ETransportUIT?.length > 0) == false){
        var request = {
          User:this.parent.User,
          Language:this.parent.getLanguage(),
          PartnerID:JSON.parse(JSON.stringify(Partner.ID)),
          DocumentNumber:DocumentNumber,
        };
    
        this.service.MatchUnallocatedUIT(request).subscribe(response => {
       
          if(response["Status"] == 1){
            this.ETransportUnAllocatedUIT = response["ETransportUnAllocatedUIT"];
            this.ETransportDetails = response["ETransportDetails"];
            this.CurrentReception.Details.ETransportDetails = JSON.parse(JSON.stringify(this.ETransportDetails));
          }
        });
      }
  }

  DupplicateDocumentReceptions:any[];

  GetDocumentDupplication(Partner:any, DocumentNumber:string, ReceptionID:string = null){

    if(Partner != null){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:JSON.parse(JSON.stringify(Partner.ID)),
        DocumentNumber:DocumentNumber,
        ReceptionID:ReceptionID
      };
  
      this.service.GetDocumentDupplication(request).subscribe(response => {
     
        if(response["Status"] == 1){
          this.DupplicateDocumentReceptions = response["Receptions"];
        }
     
      });
    }
  }

  AdjustCurrencyOnPartnerSeleciton(){
    this.GetCurrencyLiveExchange(this.partner.BillingAddress.Country.Currency);
  }

  ValidDocument:boolean;

  TestDocumentValidity(){

    this.ValidDocument = true;

    if(this.Products == null || this.Products.length == 0){
      this.ValidDocument = false;
    }

    if(this.DocumentDate.valid == false || this.PaymentDueDate.valid == false || this.StockEntryDate.valid == false){
      this.ValidDocument = false;
    }

    if(this.partner == null){
      this.ValidDocument = false;
    }
  }

  selectedFile: File = null;

  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
  }

  // 🍎 Format file size for display
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }

  // 🍎 Clear selected file
  clearSelectedFile() {
    this.selectedFile = null;
  }

  // 🍎 Upload document file and extract data
  UploadDocumentFile(){

    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('UploadedFile', this.selectedFile);
    request.append('CompanyID', this.parent.Company.ID);

    this.parent.loading = true;

    this.service.ExtractDocumentData(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

        // Populate reception fields with extracted data from GPT
        if(response["ExtractedReception"]){
          var extractedReception = response["ExtractedReception"];

          // Set document number
          if(extractedReception.DocumentNumber){
            this.CurrentReception.DocumentNumber = extractedReception.DocumentNumber;
          }

          // Set document date
          if(extractedReception.DocumentDate){
            this.DocumentDate = new FormControl(moment(extractedReception.DocumentDate));
            this.CurrentReception.DocumentDate = extractedReception.DocumentDate;
          }

          // Set currency
          if(extractedReception.Currency){
            this.currency = extractedReception.Currency;
            this.CurrentReception.Currency = extractedReception.Currency;
          }

          // Add extracted products to the reception
          if(extractedReception.Products && extractedReception.Products.length > 0){
            extractedReception.Products.forEach((product: any) => {
              this.Products.push(product);
            });
            this.CurrentReception.Products = this.Products;
          }
        }

        this.selectedFile = null;
      }

      this.parent.loading = false;
    });
  }

  UploadReceptionFile(){

    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('ReceptionID', this.CurrentReception.ID);
    request.append('UploadedFile', this.selectedFile);
    request.append('CompanyID', this.parent.Company.ID);

    this.parent.loading = true;

    this.service.UploadReceptionFile(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.CurrentReception.FilePath = response["FilePath"];
        this.selectedFile = null;
      }

      this.parent.loading = false;
    });
  }

  DownloadFile(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:r.ID,
    };
  
    this.parent.loading = true;
  
    this.service.DownloadReceptionFile(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
  
      this.parent.loading = false;
    });
  }

  DeleteFileQuestion:boolean = false;

  OpenDeleteFileQuestion(){
    this.DeleteFileQuestion = true;
  }

  DeleteFile(ID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:ID,
    };

    this.parent.loading = true;

    this.service.RemoveReceptionFile(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.FilePath = null;
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.parent.loading = false;
    });
  }

  // 🍎 Import with Indexes Methods
  GetImportConfigurationPositions(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.GetImportConfigurationPositions(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ConfigurationPositions = response["ConfigurationPositions"];
      }

      this.parent.loading = false;
    });
  }

  comparePosition(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  onSelectExcelFile(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedExcelFile = event.target.files[0];
    }
  }

  clearSelectedExcelFile() {
    this.selectedExcelFile = null;
  }

  ImportReceptionWithIndexes(){
    if(!this.selectedExcelFile){
      this.parent.openSnackBar("Please select a file first", "OK", "alert-info-snackbar");
      return;
    }

    // Validate that at least Code or Name is selected
    if(!this.CurrentReception.ImportIndexes.Name && !this.CurrentReception.ImportIndexes.Code){
      this.parent.openSnackBar("Please select at least Code or Name column index", "OK", "alert-info-snackbar");
      return;
    }

    // Validate that Quantity is selected (mandatory)
    if(!this.CurrentReception.ImportIndexes.Quantity){
      this.parent.openSnackBar("Quantity column index is mandatory", "OK", "alert-info-snackbar");
      return;
    }

    // Validate that Price is selected (mandatory)
    if(!this.CurrentReception.ImportIndexes.Price){
      this.parent.openSnackBar("Price column index is mandatory", "OK", "alert-info-snackbar");
      return;
    }

    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('UploadedFile', this.selectedExcelFile);

    // Send ImportIndexes as JSON string to avoid model binding issues with nested complex objects
    request.append('ImportIndexesJson', JSON.stringify(this.CurrentReception.ImportIndexes));

    // Send selected currency ID and partner ID
    if(this.currency && this.currency.ID){
      request.append('SelectedCurrencyID', this.currency.ID.toString());
    }
    if(this.partner && this.partner.ID){
      request.append('SelectedPartnerID', this.partner.ID);
    }

    this.parent.loading = true;

    this.service.ImportReceptionWithIndexes(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

        // Attach imported products to CurrentReception
        if(response["Products"] && response["Products"].length > 0){
          // Initialize Products array if it doesn't exist
          if(!this.CurrentReception.Products){
            this.CurrentReception.Products = [];
          }

          // Add imported products to the reception
          this.CurrentReception.Products = [...this.CurrentReception.Products, ...response["Products"]];

          // Also update the Products property used for display
          this.Products = this.CurrentReception.Products;
        }

        // Close popup and clear file
        this.ShowImportWithIndexesPopup = false;
        this.selectedExcelFile = null;

        // Test document validity to remove overlay now that we have products
        this.TestDocumentValidity();

        // Recalculate reception totals after importing products
        this.GetReceptionTotalValues();

        // Get expected PO prices for all imported products in bulk (parallel processing)
        this.GetExpectedPOProductsPricesBulk(response["Products"], this.partner);
      }

      this.parent.loading = false;
    });
  }

  AutoPrintDocument(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:i.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.ExportReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.parent.AutoPrintDocument(Document);
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company,
      SearchEUVIES:true
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["NewPartnerDetected"] == true){
  
            var p = response["PendingPartner"];
            this.newPartner = new FormGroup({
  
              VAT:new FormControl(p.VAT),
              UPN:new FormControl(''),
              Name:new FormControl(p.Name, [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(p.EUVATVerified),
          
              Country:new FormControl(p.BillingAddress.Country),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(p.BillingAddress.AddressLine),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
  
            this.showAddNewPartnerPopUp = true;
          }
          else{
            this.Partners = response["Partners"];
            this.resultsLength = response["Count"];
          }
        }
     
        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  VerifyPriceModel(p:string){
    // var result = p;
    var result = this.parent.NormalizePrice(p);
  
    if(this.CurrentProduct != null){
      if(!this.CurrentProduct.ProductReceptionInfo.PriceContainsVAT){
        this.CurrentProduct.ProductReceptionInfo.Price.UIUnitPrice = result;
      }
      else{
        this.CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPrice = result;
      }
    }
  
    if(this.NewProduct != null){
      if(!this.NewProductPriceContainsVAT){
        this.NewProduct.ProductReceptionInfo.Price.UIUnitPrice = result;
      }
      else{
        this.NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice = result;
      }
    }
  }

  ShowPaymentContainer:boolean;
  PaymentRemainingValue:any;
  PaymentCategories:any[];
  BankAccounts:any[];
  PaymentTypes:any[];

  GetPaymentsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetPaymentsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.BankAccounts = response["BankAccounts"];
        this.PaymentTypes = response["PaymentTypes"];
        this.PaymentCategories = response["PaymentCategories"].filter(x => x.ID != -1);
      }
   
      this.parent.loading = false;
    });
  }

  InitializeNewPayment(){

    this.ShowPaymentContainer = true; 
    this.currentPayment = {};
    this.currentPayment.Type = this.PaymentTypes[1];
    this.currentPayment.Currency = this.CurrentReception.Currency;
    this.currentPayment.Currency.DecimalPrecision = this.DecimalPrecisions[0];
    this.CollectionDate = new FormControl(moment());
    this.currentPayment.PaymentDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
    this.currentPayment.ID = 0;
  
    this.currentPayment.BankAccount = {};
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentPayment.Currency.ID)[0];
  
    this.currentPayment.Status = {};
    this.currentPayment.Status.ID = 0;

    this.currentPayment.Category = {};
    this.currentPayment.Category = this.PaymentCategories[0];
  
    this.currentPayment.ReceptionID = this.CurrentReception.ID;
    this.currentPayment.ReceptionDetailsID = this.CurrentReception.Details.ID;
    this.CurrentReception = this.CurrentReception;

    if(this.CurrentReception.Details.PaymentRemainingValue > 0){
      this.currentPayment.Value = JSON.parse(JSON.stringify(this.CurrentReception.Details.PaymentRemainingValue));
      this.PaymentRemainingValue = JSON.parse(JSON.stringify(this.CurrentReception.Details.PaymentRemainingValue));
    }
  }

  InitializeNewPaymentOnNewReception(){

    this.ShowPaymentContainer = true; 
    this.currentPayment = {};
    this.currentPayment.Type = this.PaymentTypes[1];
    this.currentPayment.Currency = this.currency;
    this.currentPayment.Currency.DecimalPrecision = this.DecimalPrecisions[0];
    this.CollectionDate = new FormControl(moment());
    this.currentPayment.PaymentDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
    this.currentPayment.ID = 0;

    this.currentPayment.UIID = this.parent.newGuid();
  
    this.currentPayment.BankAccount = {};
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentPayment.Currency.ID)[0];
  
    this.currentPayment.Status = {};
    this.currentPayment.Status.ID = -1;

    this.currentPayment.Category = {};
    this.currentPayment.Category = this.PaymentCategories[0];
  
    this.currentPayment.ReceptionID = null;
    this.currentPayment.ReceptionDetailsID = 0;

    this.currentPayment.Value = this.CurrentReception.Total.TotalQtyPriceVAT;
    this.PaymentRemainingValue = 0;

    this.InitializeNewPaymenOnNewReception();
  }

  DeleteNewPaymentOnNewReception(p:any){
    this.CurrentReception.Details.Payments = this.CurrentReception.Details.Payments.filter(x => x.UIID != p.UIID);
  }

  AddPayment(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Payment:this.currentPayment,
    };
  
    if(this.CollectionDate.value != null){
      if(this.CollectionDate.value._d != undefined){
        request.Payment.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
        this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
      }
      else{
        request.Payment.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
        this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
      }
    }
  
    this.parent.loading = true;
  
    this.service.AddPayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetReceptionAfterPaymentUpdate(this.CurrentReception.ID, false);
      }
  
      this.CollectionDate = new FormControl(moment());
      this.parent.loading = false;
    });
  }

  AddPaymentOnNewReception(){
    
    if(this.CurrentReception.Details.Payments == null){
      this.CurrentReception.Details.Payments = [];
    }

    this.CurrentReception.Details.Payments.push(this.currentPayment);
  }

  InitializeNewPaymenOnNewReception(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Payments:this.CurrentReception.Details.Payments,
      DecimalPrecision:this.ReceptionPrecision,
      Total:this.CurrentReception.Total,
      Currency:this.currency
    };

    this.service.InitializeNewPaymenOnNewReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.currentPayment = response["Payment"];
      }
    });
  }

  GetReceptionAfterPaymentUpdate(id:string, IncludeTaxDistributionsInPrice:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:id,
      WithInfo:true,
      IsNewStorno:this.IsStorno,
      IncludeTaxDistributionsInPrice:IncludeTaxDistributionsInPrice
    };

    this.loadingEditProduct = true;

    this.service.GetReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 30000);
        this.ShowDocumentError = true;
      }
      else if(response["Status"] == 1){
        var r = response["Reception"];
        this.CurrentReception.Details.Payments = r.Details.Payments;
        this.CurrentReception.Details.PaymentRemainingValue = r.Details.PaymentRemainingValue;
        this.CurrentReception.Status = r.Status;

        //is used only for pdf display, to eliminate the distributed taxes
        if(IncludeTaxDistributionsInPrice){
          this.CurrentReception = response["Reception"];
          this.CurrentReception.Products = this.CurrentReception.Products.filter(x => x.ProductReceptionInfo.GeneralType.IsTaxConsumed != true);
        }

        this.TestDocumentValidity();
      }
   
      this.loadingEditProduct = false;
    });
  }

  ShowSuggestionPaymentsContainer:boolean;

  OpenPayments(){
    this.ShowSuggestionPaymentsContainer = true;
  }

  ClonePayment(c:any){
    this.currentPayment = JSON.parse(JSON.stringify(c));
  
    this.PaymentCategories.forEach(c => {
      if(c.ID == this.currentPayment.Category.ID){
        this.currentPayment.Category = c;
      }
    });
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
  }

  ReselectBankAccount(c:any){
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == c.ID)[0];
  }

  ShowSuggestedPaymentModifier:boolean;

  OpenSuggestedPaymentModifier(c:any){

    this.currentPayment = c;
  
    this.PaymentCategories.forEach(c => {
      if(c.ID == this.currentPayment.Category.ID){
        this.currentPayment.Category = c;
      }
    });
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
    
    if(this.currentPayment.ReceptionDetailsID == null || this.currentPayment.ReceptionDetailsID == undefined){
      this.currentPayment.ReceptionDetailsID = "";
    }
  
    if(this.currentPayment.ReceptionID == null || this.currentPayment.ReceptionID == undefined){
      this.currentPayment.ReceptionID = "";
    }
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.PaymentDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
  }

  UpdatePayment(p:any){

    if(this.CollectionDate.value._d != undefined){
      p.PaymentDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
    }
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Payment:p,
    };
    
      this.parent.loading = true;
  
      this.service.UpdatePayment(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.GetReceptionAfterPaymentUpdate(this.CurrentReception.ID, false);
        }
     
        this.parent.loading = false;
      });
  }

  ShowDeleteSpendingQuestion:boolean;

  DeletePayment(ID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:ID,
    };
  
    this.parent.loading = true;
  
    this.service.DeletePayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.Details.Payments = this.CurrentReception.Details.Payments.filter(x => x.ID != ID);
        this.ShowDeleteSpendingQuestion = false;
        this.currentPayment = null;

        this.GetReceptionAfterPaymentUpdate(this.CurrentReception.ID, false);
      }
  
      this.parent.loading = false;
    });
  }

  ShippingWays:any[];
  ShippingServiceTypes:any[];
  ShippingResponsabilities:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  ShippingMasterData:any;

  GetShippingMasterData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetShippingMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingWays = response["ShippingWays"];
        this.ShippingServiceTypes = response["ShippingServiceTypes"];
        this.ShippingResponsabilities = response["ShippingResponsabilities"];
        this.ShippingCompanies = response["ShippingCompanies"];
        this.WeightTypes = response["WeightTypes"];
        this.ShippingMasterData = response;
      }
    });
  }

  ShowShippingDetailsContainer:boolean;

  GetShippingDetails(DetailsID:number, PartnerID:string){
    console.log('GetShippingDetails called with DetailsID:', DetailsID, 'PartnerID:', PartnerID);

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ParentDetailsID:DetailsID,
      ShippingMasterData:this.ShippingMasterData,
      PartnerID:PartnerID
    };

    this.parent.loading = true;

    this.service.GetReceptionShippingDetails(request).subscribe(
      response => {
        console.log('GetReceptionShippingDetails response:', response);

        if(response["Status"] == -1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
          this.ShowShippingDetailsContainer = true;
        }
        else if(response["Status"] == 0){
          this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar");
          this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
          this.ShowShippingDetailsContainer = true;
        }

        this.parent.loading = false;
      },
      error => {
        console.error('GetReceptionShippingDetails error:', error);
        this.parent.openSnackBar('Error loading shipping details', "OK", "alert-info-snackbar");
        this.parent.loading = false;
      }
    );
  }
  
  AddNewBox(ShippingDetailsID:number){
    var box = {
      ID:0,
      ParentShippingDetailsID:ShippingDetailsID,
      Length:10,
      Width:10,
      Height:10,
      Weight:1,
      TrackingLabel:null,
      UIID:this.parent.newGuid(),
    };
  
    this.CurrentReception.Details.ShippingDetails.Boxes.push(box);
  }
  
  ProofShippingDetails(ShippingDetails:number, SaveToDB:boolean = false){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.ProofReceptionShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowShippingDetailsContainer = false;
  
        if(SaveToDB == true){
  
          if(this.CurrentReception.Details.ShippingDetails.ID > 0){
            this.UpdateShippingDetails(this.CurrentReception.Details.ShippingDetails);
          }
          else{
            this.AddShippingDetails(this.CurrentReception.Details.ShippingDetails);
          }
        }
      }
    });
  }
  
  ShowDeleteBoxQuestion:boolean;
  CurrentBox:any;
  
  DeleteBox(UIID:string){
    this.CurrentReception.Details.ShippingDetails.Boxes = this.CurrentReception.Details.ShippingDetails.Boxes.filter(item => item.UIID != UIID);
  }
  
  AddShippingDetails(ShippingDetails:any){
    
    ShippingDetails.Partner = this.CurrentReception.Supplier;
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.service.AddReceptionShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
      }
  
      this.parent.loading = false;
    });
  }
  
  UpdateShippingDetails(ShippingDetails:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.service.UpdateReceptionShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
      }
  
      this.parent.loading = false;
    });
  } 

  DetectedPayments:any[];
  ShowDetectedPaymentsContainer:boolean;

  CheckUnAllocatedPaymentsByDocumentNumber(DocumentNumber:string){

    if(this.CurrentReception.Details.Payments != null && this.CurrentReception.Details.Payments.length > 0){
      var finalPayments = [];

      this.CurrentReception.Details.Payments.forEach(p => {
        if(this.DetectedPayments.some(x => x.UIID == p.UIID) == false){
          finalPayments.push(JSON.parse(JSON.stringify(p)));
        }
      });

      this.CurrentReception.Details.Payments = JSON.parse(JSON.stringify(finalPayments));
    }

    this.DetectedPayments = [];

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DocumentNumber:DocumentNumber,
    };
  
    this.parent.loading = true;
  
    this.service.CheckUnAllocatedPaymentsByDocumentNumber(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.DetectedPayments = response["Payments"];
      }
  
      this.parent.loading = false;
    });
  }

  OpenDetectedPayments(){
    this.ShowDetectedPaymentsContainer = true;
  }

  AcceptDetectedPayments(){
    if(this.CurrentReception.Details.Payments != null && this.CurrentReception.Details.Payments.length > 0){
      
      this.DetectedPayments.forEach(p => {
        if(this.CurrentReception.Details.Payments.some(x => x.ID == p.ID) == false){
          this.CurrentReception.Details.Payments.push(p);
        }
      });

    }
    else{
      this.CurrentReception.Details.Payments = JSON.parse(JSON.stringify(this.DetectedPayments));
    }
  }

  DeleteDetectedPayment(p:any){
    this.DetectedPayments = this.DetectedPayments.filter(x => x.UIID != p.UIID);
  }

  ChangeReceivedStatus(){

    var Received = JSON.parse(JSON.stringify(this.CurrentReception.Details.ReceivedStatus.Received));
    var newStatus = JSON.parse(JSON.stringify(this.ReceivedStatuses.filter(x => x.Received == Received)))[0];
    this.CurrentReception.Details.ReceivedStatus = JSON.parse(JSON.stringify(newStatus));
  }
}
